import React, { memo } from 'react';
import cls from './DaysModeStage.module.css';
import classNames from 'classnames';
import { StageItem } from '../../../../../../UI/StageItem/StageItem';
import moment from 'moment/moment';

export const Day = memo(({ month, stage, isPlanFact, currentDay, currentMonths }) => {
    const nowDate = moment().format('DD.MM.YYYY');

    const stageStartDate = moment(stage.planned.start_date).format('DD.MM.YYYY');

    return (
        <>
            {month.days.map((day) => (
                <div
                    key={day.day}
                    className={classNames(cls.day, {
                        [cls.factWrapper]: isPlanFact,
                        [cls.weekend]: day.isWeekend,
                        [cls.nowDate]: day.date === nowDate,
                    })}
                >
                    {day.date === stageStartDate && (
                        <StageItem isPlanFact={isPlanFact} stage={stage} />
                    )}
                </div>
            ))}
        </>
    );
});
